export default __webpack_public_path__ + "6e4f99f799f3ebda7e6cd36400c314e0.png";